"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_2 = require("redux-persist/integration/react");
const react_redux_1 = require("react-redux");
const react_i18next_1 = require("react-i18next");
const react_toastify_1 = require("react-toastify");
const store_1 = require("../../store");
const AppContextProvider_1 = __importDefault(require("./AppContextProvider"));
const i18n_1 = __importDefault(require("../../i18n"));
const ZoomContext_1 = __importDefault(require("./ZoomContext"));
const SearchContextProvider_1 = __importDefault(require("./SearchContextProvider"));
const AppMobileCommunicationContext_1 = __importDefault(require("./AppMobileCommunicationContext"));
const ApplicationProviders = ({ children }) => {
    return (react_1.default.createElement(react_i18next_1.I18nextProvider, { i18n: i18n_1.default },
        react_1.default.createElement(react_toastify_1.ToastContainer, { autoClose: 8000, position: react_toastify_1.toast.POSITION.TOP_CENTER }),
        react_1.default.createElement(react_redux_1.Provider, { store: store_1.Store },
            react_1.default.createElement(react_2.PersistGate, { loading: null, persistor: store_1.persistor },
                react_1.default.createElement(AppContextProvider_1.default, null,
                    react_1.default.createElement(AppMobileCommunicationContext_1.default, null,
                        react_1.default.createElement(SearchContextProvider_1.default, null,
                            react_1.default.createElement(ZoomContext_1.default, null, children))))))));
};
exports.default = ApplicationProviders;
